/* unplugin-vue-components disabled */import script from "./form-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-input.vue?vue&type=script&setup=true&lang=ts"

import "./form-input.vue?vue&type=style&index=0&id=e2c8fa78&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c8fa78"]])

export default __exports__